import api from './api';

const getToken = () => localStorage.getItem('token');

/**
 * Build SSE URL. If user is authenticated, append JWT token as query param.
 * For anonymous users, the backend uses the ml_agent_session cookie instead.
 */
function buildSseUrl(path, params = {}) {
  const token = getToken();
  const query = new URLSearchParams(params);
  if (token) query.set('token', token);
  const qs = query.toString();
  return qs ? `${path}?${qs}` : path;
}

export const agentService = {
  /**
   * Connect to SSE stream for next product recommendation.
   * Works for both authenticated and anonymous users.
   */
  getNextProduct: () => {
    return new EventSource(buildSseUrl('/api/agent/feed/next'), { withCredentials: true });
  },

  /**
   * Connect to SSE stream for a specific product (direct link).
   */
  getProductAgent: (productId) => {
    return new EventSource(buildSseUrl(`/api/agent/feed/product/${productId}`), { withCredentials: true });
  },

  /**
   * Send feedback for the current product.
   */
  sendFeedback: (productId, action, message = null) => {
    return api.post('/agent/feed/feedback', { productId, action, message });
  },

  /**
   * Get current session info.
   */
  getSession: () => api.get('/agent/session'),

  /**
   * Reset the agent session.
   */
  resetSession: () => api.post('/agent/session/reset'),

  /**
   * Connect to SSE stream for smart chat about current product.
   */
  sendChat: (productId, message) => {
    return new EventSource(
      buildSseUrl('/api/agent/chat', {
        productId: productId,
        message: message
      }),
      { withCredentials: true }
    );
  },
};
